import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import {
  BlackjackAssetType,
  BlackjackStylesType,
  BlackjackTranslationsType,
} from '../../model/blackjack-types';

export class StartViewModel {
  public get playLabelText() {
    return this.gameServices.gameTranslationService.getTranslation(BlackjackTranslationsType.Play);
  }
  public get buttonAsset() {
    return this.gameServices.assetCatalogueService.getAsset(BlackjackAssetType.StartButton);
  }
  public get buttonIcon() {
    return this.gameServices.assetCatalogueService.getAsset(BlackjackAssetType.PlayIcon);
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get primaryLabelColor() {
    return this.gameServices.gameThemeService.getHexColor(BlackjackStylesType.ButtonPrimaryLabel);
  }
  public get onShowStartButtonTrigger() {
    return this.showStartButtonTrigger.asObservable();
  }

  private readonly showStartButtonTrigger: BehaviorSubject<boolean>;

  constructor(private gameServices: GameServices) {
    this.showStartButtonTrigger = new BehaviorSubject<boolean>(false);
  }

  public showStartButton(showButton: boolean) {
    this.showStartButtonTrigger.next(showButton);
  }

  public startClicked() {
    this.gameServices.blackjackGameRunner.clickStartGame();
  }
}
